// useFeatureToggles.js
import { graphql, useStaticQuery } from 'gatsby';

export const useFeatureToggles = () => {
  const data = useStaticQuery(graphql`
    query toggledFeaturesQuery {
      allKontentItemToggledFeatures {
        edges {
          node {
            elements {
              feature {
                value {
                  ... on kontent_item_toggled_feature_switch {
                    id
                    elements {
                      feature {
                        value
                      }
                      cohort {
                        value {
                          name
                          codename
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return data.allKontentItemToggledFeatures.edges[0].node.elements.feature.value;
};
